module.exports = __webpack_public_path__ + "img/OrdersIcon.eff2e38a.svg";